import App from "../../App";
import {HIDE_SIDEBAR, HIDE_SIDEBAR_IF_FLOATING, SHOW_SIDEBAR, TOGGLE_SIDEBAR, TURN_OFF_SIDEBAR_FLOAT_BOAT, TURN_ON_SIDEBAR_FLOAT_BOAT} from "../Actions/sidebar";

const savedState = App.storage.get('redux', {sidebar: {}}).sidebar;

const initialState = {
    floatBoat: savedState?.floatBoat || false, // saves sidebar type to be fixed or auto hide
    show: savedState?.show || false, // saves sidebar show state
    selected: null // saves selected menu item to be highlighted
};

const reducer = (state = initialState, action) => {
    const newState = {...state};

    switch (action.type) {
        case TURN_ON_SIDEBAR_FLOAT_BOAT:
            newState.floatBoat = true;
            break;

        case TURN_OFF_SIDEBAR_FLOAT_BOAT:
            newState.floatBoat = false;
            break;

        case SHOW_SIDEBAR:
            newState.show = true;
            break;

        case HIDE_SIDEBAR:
            newState.show = false;
            break;

        case TOGGLE_SIDEBAR:
            newState.show = !state.show;
            break;

        case HIDE_SIDEBAR_IF_FLOATING:
            if (state.floatBoat)
                newState.show = false;
            break;

        default:
            return newState;
    }

    App.storage.set('redux', {
        ...App.storage.get('redux', {}),
        sidebar: newState
    });

    return newState;
};

export default reducer